import React, {Component} from 'react'
import ReGenerateLabelsPage from './ReGenerateLabelsPage'

class ReGenerateLabelsContainer extends Component{
    render() {
        return (
            <div>
                <ReGenerateLabelsPage/>
            </div>
        )
    }
}

export default ReGenerateLabelsContainer